import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import DragHandleOutlinedIcon from "@mui/icons-material/DragHandleOutlined";

import {
  Button,
  DialogActions,
  DialogContentText,
  Divider,
  TextField,
  Zoom,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardHeader from "@mui/material/CardHeader";
import Icon from "@mui/material/Icon";
import clsx from "clsx";
import { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";

import axios, * as others from "axios";
import UploadAttachmentModal from "./UploadAttachmentModal";
import {
  docs_enum,
  getFileExtention,
  images_enum,
  videos_enum,
} from "utils/helper";
import DeletePopUp from "./DeletePopup";
import { useBoundStore } from "store/store";
import { Link, useNavigate } from "react-router-dom";

const CardButton = (props: any) => {
  let lang: any = useBoundStore((state) => state.lang);

  const [target, setTarget] = useState("");
  const navigate = useNavigate();
  const loadEquipmentDetails = useBoundStore(
    (state) => state.loadEquipmentDetails
  );
  const isAuthUser = useBoundStore((state) => state.isAuthUser);
  const deleteAttachment = useBoundStore((state) => state.deleteAttachment);
  const updateAttachment = useBoundStore((state) => state.updateAttachment);
  const [showButtn, setShowButton] = useState(true); // to avoid double click
  const [fileid, setfileid] = useState("");
  const [uploadUrl, setuploadUrl] = useState("");
  const [bucketid, setbucketid] = useState("");
  const [mainFile, setMainFile] = useState({ type: "", name: "" });
  const [fileVersion, setFileVersion] = useState("");

  const [attachmentCategory, setAttachmentCategory] = useState("");

  const [UploadDialogInternal, setUploadDialogInternal] = useState(false);
  const [fileidInternal, setfileidInternal] = useState();
  const [uploadUrlInternal, setuploadUrlInternal] = useState("");
  const [bucketidInternal, setbucketidInternal] = useState();
  const [fileVersionInternal, setFileVersionInternal] = useState();
  const [NewfileInternal, setNewfileInternal] = useState<File | null>(null);

  const [openVideoDialog, setOpenVideoDialog] = useState(false);
  const [dialogVideoUrl, setDialogVideoUrl] = useState("");

  var file = NewfileInternal
    ? new File([NewfileInternal], NewfileInternal.name, {
        type: NewfileInternal.type,
      })
    : null;

  var localURL = file ? URL.createObjectURL(file) : null;

  const buttonCardHeader = (
    <>
      <CardHeader
        action={props.action}
        title={
          props.title.length > 20
            ? props.title.substring(0, 20) + "..."
            : props.title
        }
        subheader={props.subheader}
        onClick={() => {
          props.pdfUrl && window.open(props.pdfUrl, "PDF Viewer");
        }}
      />
    </>
  );
  const [openDialog, setopenDialog] = useState(false);

  const [title, settitle] = useState("");
  const [description, setdescription] = useState("");

  const handleCloseDialog = () => {
    setopenDialog(false);
    setMainFile({ type: "", name: "" });
    settitle("");
    setdescription("");
  };

  const submitform = () => {
    const attachmentnodeid = props.nodeid;
    if (mainFile != undefined) {
      const url = uploadUrl;
      const config = {
        headers: {
          "Content-Type": mainFile.type,
          "Access-Control-Allow-Origin": "*",
        },
      };
      const response = axios
        .put(url, mainFile, config)
        .then((res) => {})
        .catch(function (error) {});

      const file = {
        fileid: fileid,
        mimetype: mainFile.type,
        bucketid: bucketid,
        fileversion: fileVersion,
        nodeid: props.nodeid,
      };
      let tempTitle = title === "" ? mainFile?.name?.split(".")[0] : title;
      props.updatemachinedocument({
        lang,
        title: tempTitle,
        description,
        attachmentnodeid,
        file,
      });
    } else {
      props.updatemachinedocument({
        lang,
        title,
        description,
        attachmentnodeid,
      });
    }

    if (props.clientinfo == "machinebuilder") {
      props.GetSingleEquipmentType(props.machines[0]?.equipmenttype?.nodeid);
    } else {
      props.getSingleMachine(props.machines?.equipment?.nodeid);
    }

    handleCloseDialog();
  };

  const submitformInternal = () => {
    const attachmentnodeid = props.nodeid;
    if (mainFile != undefined) {
      const url = uploadUrlInternal;
      const config = {
        headers: {
          "Content-Type": mainFile.type,
          "Access-Control-Allow-Origin": "*",
        },
      };
      const response = axios
        .put(url, mainFile, config)
        .then((res) => {})
        .catch(function (error) {});
      const file = {
        fileid: fileidInternal,
        mimetype: mainFile.type,
        bucketid: bucketidInternal,
        fileversion: fileVersionInternal,
        nodeid: props.nodeid,
      };
      let tempTitle = title === "" ? mainFile?.name?.split(".")[0] : title;
      props.updatemachinedocument({
        lang,
        tempTitle,
        description,
        attachmentnodeid,
        file,
      });
    } else {
      props.updatemachinedocument({
        lang,
        title,
        description,
        attachmentnodeid,
      });
    }

    if (props.clientinfo == "machinebuilder") {
      props.GetSingleEquipmentType(props.machines[0]?.equipmenttype?.nodeid);
    } else {
      props.getSingleMachine(props.machines?.equipment?.nodeid);
    }

    handleCloseDialog();
  };

  const [openDialogDelete, setopenDialogDelete] = useState(false);

  const handleDialogDelete = () => {
    setopenDialogDelete(false);
  };

  const handleDelete = async () => {
    const nodeid = props.nodeid;
    const promises: any[] = [deleteAttachment(nodeid, props.machineNodeId)]; // Ensure that promises is an array

    if (isAuthUser === true) {
      try {
        const result = await Promise.all(promises);

        setTimeout(() => {
          loadEquipmentDetails(props.machineNodeId, lang);
        }, 2000);
      } catch (error) {
        console.error("Error during promise execution:", error);
      }
    }

    setopenDialogDelete(false);
  };

  const handleNewImage = (e: any) => {
    var file = e.target.files[0];
    if (e.target.files.length == 0) {
      return false;
    }
    const exstention = getFileExtention(e.target.files[0].type);
  };

  const handleNewImageInternal = (e: any) => {};

  const customFileChange = (e: any) => {
    props.type == "manufacturer"
      ? handleNewImage(e)
      : handleNewImageInternal(e);
    setShowButton(true);
  };

  const handleFormSubmit = () => {
    props.type == "manufacturer" ? submitform() : submitformInternal();
  };

  const handleEdit = () => {
    settitle(props.title);
    setdescription(props.description);

    if (props?.file) {
      setNewfileInternal(props.file);
    }

    setAttachmentCategory(props.attachmentCategory);
    setopenDialog(true);
  };

  const updateGenericAttachment = async () => {
    const attachment = {
      attachment: {
        description: null,
        file: {
          localuri: file ? localURL : props.pdfUrl,
          mimetype: file ? NewfileInternal?.type : props.fileMime,
        },
      },
    };

    const obj: any = {};

    obj["title"] = title;
    obj["description"] = description;
    obj["lang"] = lang;
    obj["nodeid"] = props.nodeid;
    obj["isattachmentof"] = props.machineNodeId;
    obj["attachment"] = attachment.attachment;
    obj["specifier"] = attachmentCategory;

    const promises: any[] = [updateAttachment(obj)]; // Ensure that promises is an array

    if (isAuthUser === true) {
      try {
        const result = await Promise.all(promises);

        setTimeout(() => {
          setAttachmentCategory("");
          loadEquipmentDetails(props.machineNodeId, lang);
        }, 2000);
      } catch (error) {
        console.error("Error during promise execution:", error);
      }
    }

    settitle("");
    setdescription("");
    setopenDialog(false);
  };

  const openPDF = (link: string) => {
    window.open(link, "PDF Viewer");
  };

  const handleCloseVideoDialog = () => {
    setOpenVideoDialog(false);
    setDialogVideoUrl("");
  };

  return (
    <>
      <Dialog
        open={openVideoDialog}
        onClose={handleCloseVideoDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ backdropFilter: "blur(4px)" }}
        TransitionComponent={Zoom}
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">Video Dialog</DialogTitle>
        <DialogContent id="alert-dialog-description">
          <video controls width={"100%"}>
            <source src={dialogVideoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseVideoDialog}>close</Button>
        </DialogActions>
      </Dialog>

      <Card
        className={"CardButton"}
        style={{
          border: 0,
          borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "0px",
          display: "flex",
          flexDirection: "row",
          textAlign: "center",
          alignItems: "center",
          marginBottom: "10px",
        }}
        variant="outlined"
      >
        <>
          <div className="attachmentWrapper">
            <div
              className="content"
              onClick={() => {
                if (props.isVideo) {
                  setOpenVideoDialog(true);
                  setDialogVideoUrl(props.pdfUrl);
                } else {
                  openPDF(props.pdfUrl);
                }
              }}
            >
              <div className="attachmentHeader">
                {props.title.length > 20
                  ? props.title.substring(0, 20) + "..."
                  : props.title}{" "}
                <span
                  style={{ marginLeft: "2px" }}
                  className="attachmentSubHeader"
                >
                  {props?.fileMime}
                </span>
              </div>
              <div className="attachmentSubHeader">{props.description}</div>
            </div>
            <div className="actionButtons">
              <div>
                {
                  <ModeEditOutlinedIcon
                    style={{
                      color: "rgba(0, 0, 0, 0.87)",
                      display: props.nodeid != undefined ? "block" : "none",
                      cursor: "pointer",
                    }}
                    onClick={handleEdit}
                  />
                }
              </div>
              <div>
                {
                  <DeleteForeverOutlinedIcon
                    style={{
                      color: "red",
                      display: props.nodeid != undefined ? "block" : "none",
                      cursor: "pointer",
                    }}
                    onClick={() => setopenDialogDelete(true)}
                  />
                }
              </div>
              <div style={{ cursor: "pointer" }}>
                <DragHandleOutlinedIcon sx={{ color: "rgba(0, 0, 0, 0.5)" }} />
              </div>
            </div>
          </div>
        </>
      </Card>

      <UploadAttachmentModal
        hasTitle
        fromDoc
        showHeader
        hasDescription
        open={openDialog}
        allowedExts={docs_enum}
        onClose={handleCloseDialog}
        file={NewfileInternal}
        setFile={setNewfileInternal}
        handleSubmit={updateGenericAttachment}
        description={description}
        setDescription={setdescription}
        title={title}
        setTitle={settitle}
        setTarget={setTarget}
        target={target}
        showButtn={showButtn}
        showActions
        editMode={openDialog}
        setAttachmentCategory={setAttachmentCategory}
        attachmentCategory={attachmentCategory}
      />

      <DeletePopUp
        open={openDialogDelete}
        handleClose={handleDialogDelete}
        handleDelete={handleDelete}
      ></DeletePopUp>
    </>
  );
};

CardButton.defaultProps = {
  size: "standard",
  fullyclickable: true,
  icon: null,
  iconcolor: "primary",
  action: null,
  title: "",
  subheader: null,
  border: "",
};

export default CardButton;
